 
import { API_SITE_CORPO } from '../api_endpoint';
import { http} from '../http';
 
export const sendEmail = async ( objectpage:object) => {  
	// console.log(objectpage)
	
	try {
		let x=API_SITE_CORPO.SEND_MAIL   
		let { data } = await http.post(x,objectpage);
		return data;
	} catch (error) {
		console.error(error); 
		 
	}
};
